<template>
    <Dialog v-model="show" title="COTAS DESEJADAS" width="500" :unlimit-height="true" show-close-button>
        <v-layout column class="pa-4">
            <p class="font-weight-bold">Escolha a quantidade de cotas que deseja reservar:</p>
            <v-layout align-center justify-center class="mt-4">
                <Counter :max-value="maxCotasReservar" v-model="quantidade_cotas" :can-add="permite_multiplicar_cota" :limit-message="limitMessage"></Counter>
            </v-layout>

            <p class="text-body-1 font-weight-bold text--neutral text-center mt-6">
                Max. de cotas para reservar: {{ maxCotasReservar }}*
            </p>
            <p class="text-body-1 font-weight-bold text--neutral text-center mt-1">
                Cotas disponíveis do grupo: {{ cotas.length }}*
            </p>

            <p class="text-body-1 text-start mt-2 text--gray font-weight-bold">
                Escolher a quantidade de cotas só está habilitado para o mesmo grupo*
            </p>
            <div class="text-body-1 text-start text--gray font-weight-bold">
                As cotas reservadas poderão ser utilizadas para mais de um cliente*
            </div>

            <v-layout justify-space-between align-center mt-6>
                <v-btn id="ButtonVoltar" class="col-4 col-md-3 font-weight-bold" color="secondary" @click="voltar()" text> Voltar </v-btn>
                <v-btn class="col-4 col-md-3 font-weight-bold" color="primary" @click="avancar()"> Avançar </v-btn>
            </v-layout>
        </v-layout>
    </Dialog>
</template>

<script>
  import { mapState } from 'vuex'
  import Counter from '../../components/common/Counter.vue'
  import { orderBy } from 'lodash'
  import { notification } from '../../plugins/helpers'
  import { AlertTypes } from '../../plugins/alerts_types'

  export default {
    name: 'DialogQuantidadeCotas',
    components: { Counter },
    props: {
      value: { type: Boolean, default: false },
      grupo: {
        type: Object
      },
      quantidadeCotas: { type: Number, default: 1 },
      showBackButton: { type: Boolean, default: false }
    },
    data: () => ({
      reserva: {},
      quantidade_cotas: 1,

      cotas: []
    }),
    computed: {
      ...mapState([
        'id_comissionado_venda',
        'id_comissionado',
        'id_empresa',
        'jornada_venda',
        'permite_multiplicar_cota',
        'limite_cotas_para_reservar_ativo',
        'quantidade_cotas_reservar'
      ]),
      limitMessage () {
        return this.permite_multiplicar_cota ? 'Limite Alcançado!' : 'Esse recurso está em construção, será liberado em breve!'
      },
      maxCotasReservar () {
        if (this.limite_cotas_para_reservar_ativo) {
          if (this.quantidade_cotas_reservar < this.cotas.length) {
            return this.quantidade_cotas_reservar
          }
          return this.cotas.length
        }
        return this.cotas.length
      },
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    watch: {
      value (value) {
        this.quantidade_cotas = this.quantidadeCotas
        if (value) {
          this.$http.get('/reservas/cotas', {
            params: {
              ID_Empresa: this.grupo.ID_Empresa,
              ID_Grupo: this.grupo.ID_Grupo
            }
          })
            .then(result => {
              this.cotas = result.data
              if (!this.cotas) {
                throw Error('Grupo sem cota disponível para a reserva.')
              }
              this.cotas = orderBy(this.cotas, ['CD_Cota'])
            })
            .catch(() => notification(AlertTypes.ERROR, 'Ocorreu uma falha na comunicação com o Newcon, tente novamente mais tarde! Caso persistir, por favor, entre em contato com a Administradora.'))
        } else {
          this.term = null
        }
      }
    },
    mounted () {
      this.quantidade_cotas = this.quantidadeCotas
    },
    methods: {
      voltar () {
        this.show = false
        this.$emit('voltar')
      },
      avancar () {
        this.$emit('setQuantidadeCotas', this.quantidade_cotas)
        this.quantidade_cotas = 1
      }
    }
  }
</script>
